import { gql } from "@apollo/client";

const UPLOAD_MEDIA = gql(`
mutation UploadMedia($fileName: String!, $fileType: String!, $isEvent: Boolean) {
  uploadMedia(fileName: $fileName, fileType: $fileType, isEvent: $isEvent, ) {
    id
    publicUrl
    uploadUrl
  }
}`);

const SET_MEDIA_PUBLIC = gql(`
mutation SetMediaPublic($setMediaPublicId: ID!, $isEvent: Boolean) {
  setMediaPublic(id: $setMediaPublicId, isEvent: $isEvent)
}`);

export { UPLOAD_MEDIA, SET_MEDIA_PUBLIC };
